import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconCheckmark2"><Path fillRule="evenodd" clipRule="evenodd" d="M21.7425 2.99454C22.2979 3.40464 22.4156 4.18729 22.0055 4.74263L10.0055 20.9926C9.80427 21.2652 9.501 21.4443 9.16518 21.4891C8.82936 21.5339 8.48974 21.4404 8.22411 21.2301L2.22411 16.4801C1.68284 16.0516 1.59143 15.2655 2.01993 14.7242C2.44844 14.1829 3.2346 14.0915 3.77587 14.52L8.76235 18.4677L19.9944 3.25753C20.4045 2.70218 21.1872 2.58444 21.7425 2.99454Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2;
